import {
  LINK_NAME_TYPE,
  LINK_NAME_TYPE_MINIGAME,
  SORT_LABEL,
  BRAND_ENUM,
  PAGE_TYPES,
  DELIVERY_MODE,
  DYNAMIC_CREATIVE_TYPE,
  WXGAME_PLAYABLE_TRIGGER_TYPE,
  WXGAME_PLAYABLE_PAGE_END_TIME
} from './creative-const.js'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import { SITE_ENUM } from './siteset/siteset-const.js'
import { PLATFORM } from './project-const.js'
// 不需要显示的属性
const excludeFloatingZoneProperties = [
  'chosen_button_text1',
  'chosen_button_text2',
  'chosen_button_landing_page1',
  'chosen_button_landing_page2',
  'single_image_id'
]

const excludeProperties = ['main_jump_info', 'countdown_time_type', 'countdown_expiring_timestamp']
const excludeElementTypes = ['ELEMENT_TYPE_CANVAS']
/**
 * @description:ada 由于媒体接口返回的结构有误，在此方法内进行统一过滤和修改
 * @return {*} adcreative_elements 创意内容模板结构
 * @return {*} dynamic_creative_elements 填充creativeFormModel，用于批量复制流程回显创意
 * @return {Object} creativeFormModel 创意详情的表单model
 */
export async function creativeElementsFilter(adcreative_elements) {
  const creativeTemplateStructs = []
  const creativeTemplateItems = []
  const excludeProperty = [...excludeProperties, ...excludeFloatingZoneProperties]

  const adcreativeElements = adcreative_elements.filter((ele) => !excludeElementTypes.includes(ele.element_type))

  const creativeFormModel = {}

  const videoTemplate = adcreativeElements.find((e) => e.name === 'video_options')
  const imageTemplate = adcreativeElements.find((e) => e.name === 'image_options')
  // 如果有视频素材，则不再需要显示图片素材，在视频素材选择的时候会带出图片封面素材
  if (videoTemplate && imageTemplate) {
    excludeProperty.push('image_options')
  }

  for (let i = 0; i < adcreativeElements.length; i++) {
    const ele = adcreativeElements[i]
    // element_type为结构体的元素，找到其子级元素，并保存为children
    if (ele.element_type === 'ELEMENT_TYPE_STRUCT') {
      ele.children = []

      creativeFormModel[ele.name] = {}

      for (let j = 0; j < adcreative_elements.length; j++) {
        const childEle = adcreative_elements[j]
        if (childEle.parent_name === ele.name) {
          // 浮层卡片处理
          if (childEle.parent_name === 'floating_zone_struct') {
            if (childEle.name === 'button_text') {
              childEle.element_type = 'ELEMENT_TYPE_ENUM'
              childEle.description = '按钮文字'
            }

            if (childEle.name === 'floating_zone_switch') {
              childEle.element_type = 'ELEMENT_TYPE_SWITCH'

              if (this.planForm.siteSet.includes(SITE_ENUM.CHANNELS)) {
                // 禁止浮层卡片关闭
                childEle.disabled = true
                creativeFormModel[ele.name][childEle.name] = true
              } else {
                creativeFormModel[ele.name][childEle.name] = false
              }
            }

            if (childEle.name === 'type') {
              // 浮层卡片类型，目前只接入图文复合，其他的两种暂不使用
              // 而且创意组件返回enumeration的value也与文档对应不上，这里手动覆盖
              childEle.enum_property = {
                enumeration: [
                  {
                    description: '图文复合',
                    value: 'FLOATING_ZONE_TYPE_IMAGE_TEXT'
                  }
                ]
              }
            }
          }

          // 选择视频号
          if (childEle.parent_name === 'wechat_channels_spec' && childEle.name === 'username') {
            childEle.element_type = 'ELEMENT_TYPE_ENUM'
            childEle.description = '选择视频号'
            try {
              // 获取视频号列表
              const data = await this.getPromotedObjectList()
              const enumeration = data.map((item) => {
                return {
                  description: item.promoted_object_name,
                  value: item.promoted_object_id
                }
              })
              childEle.enum_property = {
                enumeration
              }
            } catch (e) {
              console.log('getPromotedObjectList output: ', e)
            }
          }

          // 品牌图片，浮层卡片创意图等..定义为ICON类型
          if (['brand_img', 'image_id'].includes(childEle.name)) {
            childEle.element_type = 'ELEMENT_TYPE_ICON'
          }

          // 横板三小图
          if (childEle.parent_name === 'element_story' && childEle.name === 'image') {
            childEle.element_type = 'ELEMENT_TYPE_THREE_IMAGE'
            // 三小图素材默认初始化3个长度个数
            creativeFormModel[ele.name][childEle.name] = [{}, {}, {}]
          }

          // 标签内容设置非必填
          if (childEle.parent_name === 'label' && childEle.name === 'content') {
            childEle.required = false
          }

          // 排除不需要的属性
          if (!excludeProperty.includes(childEle.name)) {
            // 只有需要的属性才进行初始化
            if (typeof creativeFormModel[ele.name][childEle.name] === 'undefined') {
              creativeFormModel[ele.name][childEle.name] = ''
            }

            ele.children.push(childEle)
          }
        }
      }

      // 浮层卡片排序
      if (ele.name === 'floating_zone_struct') {
        // 把浮层卡片开关放在最前面
        ele.children = ele.children.sort((a, b) => (a.name === 'floating_zone_switch' ? -1 : 1))
      }

      // 标签去掉类型，只保留标签内容，并且禁用
      if (ele.name === 'label') {
        ele.children = ele.children.filter((l) => l.name === 'content').map((l) => ({ ...l, disabled: true }))
      }

      creativeTemplateStructs.push(ele)
    } else {
      // 没有父级结构体的属性
      if (!ele.parent_name) {
        if (!excludeProperty.includes(ele.name)) {
          creativeFormModel[ele.name] = {}

          if (ele.name === 'button_text') {
            ele.element_type = 'ELEMENT_TYPE_ENUM'
            ele.description = '按钮文字'
            creativeFormModel[ele.name] = ''
          }

          // 是否保存至视频号更改类型为switch开关
          if (ele.name === 'finder_object_visibility') {
            ele.element_type = 'ELEMENT_TYPE_SWITCH'
            ele.required = false
            creativeFormModel[ele.name] = false
          }

          if (ele.name === 'description_options') {
            // 多个输入框类型
            ele.element_type = 'ELEMENT_TYPE_MULTI_TEXT'
            ele.description = '文案'

            // 默认新增一条
            creativeFormModel[ele.name] = [{ text: '' }]
          }

          // 方形大图文案
          if (ele.name === 'title_options') {
            ele.element_type = 'ELEMENT_TYPE_MULTI_TEXT'
            creativeFormModel[ele.name] = [{ text: '' }]
          }

          // 视频，为视频初始化接收参数
          if (ele.name === 'video_options') {
            creativeFormModel[ele.name] = []
            // 上面 excludeProperty 过滤的图片素材的限制加到video_options上，用于element-type-video.vue显示
            // 朋友圈和公众号都没有image_options，所以imageTemplate为undefined
            // 如果没有image_options，那么不校验封面尺寸和大小，也不能替换视频封面
            if (imageTemplate) {
              ele.restriction.image_restriction = imageTemplate.restriction.image_restriction
            }
          }

          // 多图
          if (ele.name === 'image_options') {
            creativeFormModel[ele.name] = []
          }

          if (typeof creativeFormModel[ele.name] === 'undefined') {
            creativeFormModel[ele.name] = ''
          }

          creativeTemplateItems.push(ele)
        }
      }
    }
  }

  // 手动排序
  const a = {
    creativeTemplates: creativeTemplateStructs.concat(creativeTemplateItems).sort((a, b) => SORT_LABEL[a.name] - SORT_LABEL[b.name]),
    creativeFormModel
  }
  console.log('aaaaaaaaaaaaaaaaaa output: ', a)
  return a
}

/**
 * @description: 根据详情名称获取素材尺寸、素材类型
 * @param {*} prop
 * @param {*} creativeType prop.name
 * @param {*} max 同时可选个数
 * @return {size: 1280*720, assetType: 1}
 */
export function getSizeByTemplate(prop, creativeType) {
  const { restriction } = prop
  let rect = []
  let type = ''
  let max = 1

  switch (creativeType) {
    case 'video_options':
      rect = [restriction.video_restriction.min_width, restriction.video_restriction.min_height]
      type = MATERIAL_TYPE.VIDEO
      max = 30
      break

    case 'image_options':
      rect = [restriction.image_restriction.width, restriction.image_restriction.height]
      type = MATERIAL_TYPE.IMAGE
      max = 30
      break

    case 'poster':
      rect = [restriction.image_restriction.width, restriction.image_restriction.height]
      type = MATERIAL_TYPE.POSTER
      max = 1
      break

    /* 浮层卡片的创意图片 */
    /* 品牌图片 */
    case 'image_id':
    case 'brand_img':
      rect = [restriction.image_restriction.width, restriction.image_restriction.height]
      type = MATERIAL_TYPE.LOGO
      max = 1
      break

    /* 横板三小图 */
    case 'image':
      rect = [restriction.image_restriction.width, restriction.image_restriction.height]
      type = MATERIAL_TYPE.IMAGE

      max = 1
      break

    default:
      break
  }
  return {
    size: rect.join('*'),
    assetType: MATERIAL_TYPE_ID[type],
    max
  }
}

/**
 * @description: ada生成创意组表单
 * @return {*}
 */
export function makeCreativeForm() {
  const len = (this.creativeFormGroups?.length || 0) + 1
  return {
    idea_type: 2, // 动态创意类型，计划提交时需要
    groupName: `创意组${len}`,
    name: this.planForm?.project_name || '',
    creativeTemplates: []
  }
}

export const getWxgamePlayablePage = () => {
  return {
    wxgame_playable_page_switch: false,
    wxgame_playable_page_end_cover_img: { url: '' },
    wxgame_playable_page_end_desc: '',
    wxgame_playable_page_path: '',
    wxgame_playable_page_end_time_type: WXGAME_PLAYABLE_PAGE_END_TIME.THIRTY_SECONDS
  }
}

export const getWxgamePlayableComponent = () => {
  return {
    switch: false,
    wxgame_playable_page_path: '', // 试玩页
    end_cover_img: {}, // 结束页图片 1280*720
    wxgame_playable_page_end_desc: '', // 结束页文案
    wxgame_playable_page_trigger_types: [WXGAME_PLAYABLE_TRIGGER_TYPE.CARD], // 朋友圈试玩开启方式
    wxgame_playable_page_trigger_text: '', // 按钮文案
    card_link_image: {}, // 图片 800*800
    wxgame_playable_page_card_link_description: '', // 文案
    wxgame_playable_page_end_time_type: WXGAME_PLAYABLE_PAGE_END_TIME.THIRTY_SECONDS
  }
}

/**
 * @description: 腾讯广告v3创意表单
 */
export function getV3CreativeForm() {
  const { ch_platform_id } = this.planForm
  // 设置默认跳转落地页
  const pageType = ch_platform_id === PLATFORM.MINIGAME ? PAGE_TYPES.WECHAT_MINI_GAME : PAGE_TYPES.OFFICIAL

  return {
    delivery_mode: DELIVERY_MODE.COMPONENT,
    dynamic_creative_type: DYNAMIC_CREATIVE_TYPE.PROGRAM,
    description_component_options: [{ value: '' }], // 搜索广告创意参数
    groupName: '',
    dynamic_creative_name: '',
    creative_template_id: 910, // 激励浏览广告
    selectedAssets: {}, // 已选素材
    description: [], // 创意文案
    components: {
      brand: {
        brandInfo: { brand_id: '' },
        profileInfo: { profile_id: '' },
        brandType: BRAND_ENUM.PROFILE // 品牌形象跳转类型
      },
      text_link: {
        switch: false,
        value: '',
        page_type: pageType
      },
      mini_card_link: {
        // 图文链接
        switch: false,
        page_type: pageType,
        mini_card_link_image: {
          url: ''
        },
        mini_card_link_button_text: '',
        mini_card_link_description: ''
      },
      action_button: {
        switch: true,
        // 根据平台类型设置默认值
        value: ch_platform_id === PLATFORM.MINIGAME ? LINK_NAME_TYPE_MINIGAME[0].label : LINK_NAME_TYPE[0].label
      },
      app_gift_pack_code: {
        switch: false,
        description: '',
        code: ''
      },

      label: [],
      floating_zone: {
        floating_zone_switch: false,
        floating_zone_image: {},
        floating_zone_name: '',
        floating_zone_desc: '',
        floating_zone_button_text: '',
        floating_zone_type: 'FLOATING_ZONE_TYPE_IMAGE_TEXT'
      },
      wxgame_playable_component: getWxgamePlayableComponent(), // 小游戏试玩营销组件
      wxgame_playable_page: getWxgamePlayablePage(), // 批量复制、批量修改、单条修改广告创意试玩结束页配置
      wxgame_playable_material_config: {
        // 手动匹配的激励浏览计划试玩素材
        account: null,
        playable_page_path: '',
        playable_item: null,
        wxgame_playable_page_end_cover_img: null,
        wxgame_playable_page_end_time_type: WXGAME_PLAYABLE_PAGE_END_TIME.THIRTY_SECONDS
      },
      barrage: [],
      show_data: {
        switch: false,
        conversion_data_type: 'CONVERSION_DATA_ADMETRIC', // CONVERSION_DATA_APP_DOWNLOAD 用于下载量， CONVERSION_DATA_ADMETRIC 转换目标量
        conversion_target_type: ''
      },
      social_skill: {
        social_skill_first_comment_switch: false,
        social_skill_first_comment: ''
      },
      end_page: {
        switch: false,
        end_page_type: 'END_PAGE_AVATAR_NICKNAME_HIGHLIGHT', // END_PAGE_AVATAR_NICKNAME_HIGHLIGHT 突出头像昵称 ， END_PAGE_DESCRIPTION_HIGHLIGHT 突出文案
        end_page_desc: ''
      },
      wechat_channels: {
        finder_object_visibility: false,
        username: ''
      }
    }
  }
}
